const translations = {
  "en": {
    "Discover More": "Discover More",
    "Start Earning Aura Now": "Start Earning Points Now",
    "Turn tweets into rewards and level up Edgen's AI: your quick-start guide.": "Turn tweets into rewards and level up Ed's AI: your quick-start guide."
  },
  "zh-tw": {
    "Discover More": "探索更多",
    "Start Earning Aura Now": "立即開始賺取 Points",
    "Turn tweets into rewards and level up Edgen's AI: your quick-start guide.": "將推文轉化為獎勵，升級 Ed 的 AI：你的快速入門指南。"
  }
};

export default translations;
